import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const eachSecScroll = function () {
    const $origin = $('#ASUS-features #section-origin');
    const $buy = $('#ASUS-features #section-buy');
    // const $built = $('#ASUS-features #section-built');

    // const $box = $('#ASUS-features #section-box');
    // const $saga = $('#ASUS-features #section-saga');
    // const $components = $('#ASUS-features #section-components');
    // const $gamingCompanion = $('#ASUS-features #section-gamingCompanion');


    function eachSectionAct($sectionBase, customStartPoint, mobileStartPoint) {
        const $secScrollWindow = $(window),
        $slider = $sectionBase.find('.slider');

        let startPoint;

        if (customStartPoint) {
            startPoint = customStartPoint;
        } else if ($secScrollWindow.width() > 735) {
            startPoint = 'top-=10% center';
        } else {
            startPoint = 'top center';
        }

        // 若有提供 mobileStartPoint，優先套用到小螢幕邏輯
        if (mobileStartPoint && $secScrollWindow.width() <= 735) {
            startPoint = mobileStartPoint;
        }

        gsap.to($sectionBase, {
            scrollTrigger: {
                trigger: $sectionBase,
                start: startPoint,
                end: 'bottom top-=50%',
                // end: `+=${$sectionBaseHeight}`,
                markers: false,
                onEnterBack: (self) => sectionEnter(self),
                onEnter: (self) => sectionEnter(self),
                // onLeaveBack: (self) => sectionLeave(self),
                // onLeave: (self) => sectionLeave(self),
                onUpdate: (self) => sectionUpdate(self)
            }
        });
        gsap.to($sectionBase, {
            scrollTrigger: {
                trigger: $sectionBase,
                start: 'top bottom', // 当 $designSection 的顶部离开视口底部时
                end: 'bottom top',   // 当 $designSection 的底部离开视口顶部时
                // end: `+=${$sectionBaseHeight}`,
                markers: false,
                onLeaveBack: (self) => sectionLeave(self),
            }
        });
        function sectionEnter(self) {
            $sectionBase.addClass('active');
            //防止Slick的slick-cloned
            if ($slider.length > 0) {
                // console.log($slider);
                const $clonedSlides = $slider.find('.slick-cloned');
                const $lazyloadImg = $clonedSlides.find('.img');
                // console.log($lazyloadImg);
                $lazyloadImg.each(function() {
                    const $this = $(this);
                    $this.removeClass('lazyLoad').addClass('fadeIn, animated');
                });
            }
        
        }
        function sectionLeave(self) {
            $sectionBase.removeClass('active');
            // if($cubeParticleLength == 1) {
            //     videoElement.currentTime = 0;
            //     videoElement.pause();
            // }
        }
        function sectionUpdate(self) {
        }
    }

    eachSectionAct($origin, 'center center+=50%', 'center center+=50%');
    eachSectionAct($buy, 'center center+=80%', 'center center+=80%');

    if (window.innerWidth <= 767) {
        eachSectionAct($origin, 'top bottom-=5%', 'top bottom-=5%');
        eachSectionAct($buy, 'top bottom-=5%', 'top bottom-=5%');
    }
    // eachSectionAct($components, 'center center+=50%', 'center center+=50%');
    // eachSectionAct($gamingCompanion, 'center center+=50%', 'center center+=50%');

    
}
export default eachSecScroll;